module.exports = __webpack_public_path__ + "static/media/2839.62a4cbba.jpg";